(function (window, document, $, undefined) {
	$(function () {

		/**
		 * Banner Slider
		 */
		$('.jsBannerSliderWrapper').each(function () {

			var $wrapper = $(this);
			var $mainSlider = $wrapper.find('.jsBannerSlider');

			$mainSlider.slick({
				dots: false,
				arrows: false,
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				swipe: true,
				draggable: true,
				autoplay: true,
				autoplaySpeed: 4000,
				fade: true,
			});

		});

		$("a[rel=gallery_group]").fancybox();

		$('.jsMobileMenuToggler').each(function () {
			var $btn = $(this);
			var $menu =  $btn.parent().find('.jsMobileMenu')
			$btn.on('click', function(e){
				e.preventDefault();
				$menu.slideToggle();
			})
		});

	$('.jsMobileContactToggler').each(function () {
			var $btn = $(this);
			var $contactWrapper =  $btn.parent().find('.jsMobileContact')

			$btn.on('click', function(e){
				e.preventDefault();
				$contactWrapper.slideToggle();

			})
		});

});
})(window, document, jQuery);
